module.exports = __webpack_public_path__ + "teqbahn-assets/media/Banner.0b904cf2.png";